import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from 'services/baseApi';
import tableCacheSlice from './slices/tableCacheSlice';
import transportOrderFilesReducer from "./slices/transportOrderFiles.slice";
import transportOrderContainerCostSlice from './slices/transportOrderContainerCost.slice';
const store = configureStore({
  reducer: {
    // Add the API reducer
    [baseApi.reducerPath]: baseApi.reducer,
    tableCache: tableCacheSlice,
    transportOrderFiles: transportOrderFilesReducer,
    transportOrderContainerCosts: transportOrderContainerCostSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
